import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useImperativeHandle,
} from 'react';
import { NavLink } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import bot_icon from './../../../../../assets/bot_icon.png';
import {
  Card,
  CardBody,
  CardTitle,
  Badge,
  CardImg,
  Button,
  Row,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup,
  InputGroupAddon,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  CustomInput,
  UncontrolledDropdown,
} from 'reactstrap';
import {
  gAPI_TicketsRecording_id,
  postAPI_Ticket_SendText,
  postAPI_Create_QuickReply,
  gAPI_QuickReplyDelete_ById,
  Upload_Email_Attachment,
  putAPI_UpdateChatStatus_By_Id,
  pAPI_Update_Message,
  Upload_LiveChat_Attachment,
} from '../../../../../constants/APIs';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
  AxiosPublicAPI,
} from '../../../../../helpers/AxiosAPI';
import AppLocale from '../../../../../lang';
import { IntlProvider } from 'react-intl';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import Select from 'react-select';
import ChatMessage from '../../../../../components/chats/ChatMessage';
import ChatInput from './ChatInput';
import {
  reactSelectOption,
  reactSelectOptionDiffrentPro,
} from '../../../../../helpers/Utils';
import { ref } from 'yup';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.bubble.css';
import AutonomousReplies from '../../agentAssist/Components/EmailAssistant/autonomousReplies';
import UploadAttachments from '../../agentAssist/Components/EmailAssistant/uploadAttachments';
import UploadLiveChatAttachments from '../../agentAssist/Components/uploadLiveChatAttachments';
import Templates from '../../agentAssist/Components/EmailAssistant/templates';
const TWILIO_END_CONVERSATION =
  process.env.REACT_APP_CHAT_API + '/endTwilioConversation';
const TWILIO_CHECKCHAT_URL = process.env.REACT_APP_CHAT_API + '/checkchat';
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
};
const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];

const styles = `
    .ql-toolbar {
       border: 0px!important;
       background: rgb(233, 238, 244);
  border-radius: 20px;
    }

    .ql-editor {
      min-height: 20px !important;
    max-height: 300px !important;
  overflow-y: auto;
    }

    .ql-container{
      border: 0px!important;
      background: rgb(233, 238, 244);
    } 
`;

const Chat = React.forwardRef(
  (
    {
      chat,
      emailIntegration,
      accessToken,
      twilioConversations,
      twilioChatId,
      forceRefresh,
      closeTwilioConversation,
      profileName,
      userName,
      propertyId,
      locale,
      stopBlink,
      chatReplyTemplates,
      setBlankTwilioId,
      availabilityIntegration,
      handleEmailRefresh,
      translateLang,
      isLatestConversation,
      isTranslate,
      openWhatsAppTab,
      twilioConnectionToUserChat,
    },
    ref
  ) => {
    const intl = useIntl();

    const [showTemplate, setShowTemplate] = useState(false);
    const [uploadAttachment, setUploadAttchment] = useState(false);
    const [uploadLiveChatAttachment, setUploadLiveChatAttachment] =
      useState(false);
    const [files, setFiles] = useState();
    const [image, setImage] = useState('');
    const [replayDivHeight, setReplayDivHeight] = useState(20);
    const [messages, setMessages] = useState([]);
    const [isTyping, setTyping] = useState(false);
    const [newmessage, setNewMessae] = useState('');
    const [twilioChatClient, setTwilioChatClient] = useState(null);
    const [quickReplies, setQuickReplies] = useState(chatReplyTemplates || []);
    const [isQuick, setIsQuick] = useState(false);
    const messagesEndRef = useRef(null);
    const stateRef = useRef();
    stateRef.current = twilioChatId;
    // track pending popup timers per conversation sid so they can be cancelled
    const popupTimersRef = useRef({});

    useImperativeHandle(ref, () => ({
      loadNewMessage(message) {
        loadNewMessage(message);
      },
    }));
    const handleChange = (e) => {
      setNewMessae(e.target.value);

      // if agent starts typing, cancel any pending popup for the current conversation
      try {
        const sid = stateRef.current;
        if (sid && popupTimersRef.current && popupTimersRef.current[sid]) {
          clearTimeout(popupTimersRef.current[sid]);
          delete popupTimersRef.current[sid];
        }
      } catch (err) {
        console.error('Error clearing popup timer on typing:', err);
      }

      twilioChatClient.typing().catch((e) => {
        console.error('Got an error:', e.code, e.message);
        if (e.message.includes('Unable to connect')) {
          twilioConnectionToUserChat(
            chat.botConversationId,
            chat.visitor.location,
            chat.visitor.ipAddress,
            chat.conversationId,
            chat.channel
          );
        }
      });
    };
    const currentLang = translateLang || locale;
    const messagesForLocale =
      AppLocale[currentLang]?.messages || AppLocale['en'].messages;

    const handleUploadAttachment = () => setUploadAttchment(!uploadAttachment);
    const handleUploadLiveChatAttachment = () =>
      setUploadLiveChatAttachment(!uploadLiveChatAttachment);

    const handleTemplate = () => setShowTemplate(!showTemplate);

    const handleFiles = (list) => setFiles(list);
    const handleLiveChatFiles = async (list, image) => {
      if (!isLatestConversation && chat?.channel === 'WhatsApp') {
        openWhatsAppTab(chat?.visitor?.whatsAppSenderPhoneNumber || '');
      } else {
        console.log('image in chat', image);
        console.log('list in chat', list);
        if (image !== undefined && image !== null && image !== '') {
          //      const file = await fetch(image.src);
          //     const fileBlob = await file.blob();
          const mes = 'imageUrl:' + image.src;
          console.log('mes', mes);
          twilioChatClient.sendMessage(mes).catch((e) => {
            console.error('Got an error:', e.code, e.message);
            if (e.message.includes('Unable to connect')) {
              twilioConnectionToUserChat(
                chat.botConversationId,
                chat.visitor.location,
                chat.visitor.ipAddress,
                chat.conversationId,
                chat.channel
              );
            }
          });
          // // Send a media message
          // const sendMediaOptions = {
          //     contentType: file.headers.get("Content-Type"),
          //     media: fileBlob
          // };

          // await twilioChatClient.prepareMessage().addMedia(sendMediaOptions).build().send();
        }

        if (list !== undefined && list !== null && list.length > 0) {
          console.log('files', list);
          list.forEach(async (file) => {
            const data = new FormData();
            data.append('files', file.img);
            await AxiosAPI({
              method: 'post',
              url: `${Upload_LiveChat_Attachment}`,
              data: data,
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }).then((res) => {
              console.log('res upload', res.data);

              const mes =
                'imageUrl:' +
                `${process.env.REACT_APP_LIVECHAT_MEDIA_URL}${res.data.status}`;

              twilioChatClient.sendMessage(mes).catch((e) => {
                console.error('Got an error:', e.code, e.message);
                if (e.message.includes('Unable to connect')) {
                  twilioConnectionToUserChat(
                    chat.botConversationId,
                    chat.visitor.location,
                    chat.visitor.ipAddress,
                    chat.conversationId,
                    chat.channel
                  );
                }
              });
            });
          });
        }
      }
    };
    const saveAsDraft = () => {
      if (
        messages != null &&
        messages.length > 0 &&
        messages.filter((f) => f.isDraft !== undefined && f.isDraft === true)
          .length > 0
      ) {
        updateDraftMessage(true);
      } else {
        sendMessage(true);
      }
    };

    const updateDraftMessage = (draft, attachments) => {
      if (
        messages.filter((f) => f.isDraft !== undefined && f.isDraft === true)
          .length > 0
      ) {
        let obj = messages.filter(
          (f) => f.isDraft !== undefined && f.isDraft === true
        )[0];
        AxiosAPI({
          method: 'put',
          url: `${pAPI_Update_Message}/${obj.messageId}`,
          data: {
            isDraft: draft,
            attachments: attachments,
            groupId: getGroupID(),
            content: {
              type: 'message-email',
              messages: [newmessage],
            },
          },
        }).then((res) => { });
      }
    };

    const sendMessage = async (draft = false) => {
      if (chat?.channel !== 'EmailDirectLine') {
        console.log(255, isLatestConversation && chat?.channel === 'WhatsApp');
        if (!isLatestConversation && chat?.channel === 'WhatsApp') {
          console.log(chat);
          openWhatsAppTab(chat?.visitor?.whatsAppSenderPhoneNumber || '');
        } else {
          twilioChatClient.sendMessage(newmessage).catch((e) => {
            console.error('Got an error:', e.code, e.message);
            if (e.message.includes('Unable to connect')) {
              twilioConnectionToUserChat(
                chat.botConversationId,
                chat.visitor.location,
                chat.visitor.ipAddress,
                chat.conversationId,
                chat.channel
              );
            }
          });
        }
        //console.log('twilioChatClient', twilioChatClient);
        //

        stopBlink();
        setNewMessae('');
      } else if (newmessage !== '') {
        let attachments = [];
        if (files !== undefined && files.length > 0) {
          const result = await handleAttachmentUpload(chat?.sessionId);
          if (result?.data && result.data.length > 0) {
            result.data.map((m) => {
              attachments.push({
                shortName: m.shortName,
                fileName: m.fileName,
                contentType: m.contentType,
              });
            });
          }
        }
        let email = '';
        if (emailIntegration !== undefined) {
          email = emailIntegration?.channelDetails?.forwardingEmail;
        }
        let body = {
          gid: getGroupID(),
          iid: chat?.integrationId,
          pid: chat?.propertyId,
          vid: chat?.visitorId,
          asDraft: draft,
          sid: chat?.sessionId,
          fromEmail: email,
          emailContent: newmessage,
          recipients: chat?.visitor?.email,
          from: userName + ' from Myma.ai <' + email + '>',
          toEmail: chat?.visitor?.email,
          attachments: attachments,
          subject: chat?.visitor?.subject,
          time: moment(),
          messageThreadId: chat?.messageThreadId,
          source: 'Bot',
          message: {
            type: 'message-email',
            messages: [newmessage],
          },
        };
        if (!isDraftMessage()) {
          let url = '';
          if (draft) url = `${process.env.REACT_APP_CHAT_API}/save-draft`;
          url = `${process.env.REACT_APP_CHAT_API}/save-email-reply`;
          AxiosPublicAPI({
            method: 'post',
            url: url,
            data: body,
          }).then((res) => {
            if (!draft) {
              setNewMessae('');
              handleEmailRefresh();
              if (
                messagesEndRef !== undefined &&
                messagesEndRef.current !== null
              ) {
                messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
              }
            }
          });
        } else {
          let url = `${process.env.REACT_APP_CHAT_API}/send-draft-email`;
          AxiosPublicAPI({
            method: 'post',
            url: url,
            data: body,
          }).then((res) => {
            updateDraftMessage(false, attachments);
            if (!draft) {
              setNewMessae('');
              handleEmailRefresh();
              if (
                messagesEndRef !== undefined &&
                messagesEndRef.current !== null
              ) {
                messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
              }
            }
          });
        }
      }
    };

    const handleAttachmentUpload = async (sessionId) => {
      const data = new FormData();
      files.forEach((file) => {
        data.append('files', file.img);
      });
      data.append('sessionId', sessionId);
      data.append('creator', 'dashboard');
      return await AxiosAPI({
        method: 'post',
        url: `${Upload_Email_Attachment}`,
        data: data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    };

    const isDraftMessage = () => {
      if (
        messages != null &&
        messages.length > 0 &&
        messages.filter((f) => f.isDraft !== undefined && f.isDraft === true)
          .length > 0
      )
        return true;
      else return false;
    };

    const loadNewMessage = (message) => {
      setMessages((messages) => [...messages, message]);
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    const closeChat = () => {
      if (chat?.channel === 'WebsiteDirectLine') {
        twilioChatClient
          .sendMessage(`Agent ${profileName} has left the conversation`)
          .catch((e) => {
            console.error('Got an error:', e.code, e.message);
          });
      }

      // fetch(TWILIO_END_CONVERSATION, {
      //   method: 'POST',
      //   headers: {
      //     Accept: 'application/json',
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify({ twilioConversationId: twilioChatId }),
      // }).then((res) => {});
      setTwilioChatClient(null);
      closeTwilioConversation(
        stateRef.current,
        chat.conversationId,
        chat?.channel
      );
      stopBlink();
    };
    useEffect(() => {
      if (chat) {
        let messages = chat.messages;
        messages.map((m) => {
          if (chat?.fullMessages) {
            let obj = chat?.fullMessages.filter(
              (f) => f.messageId === m.messageId
            );

            if (obj.length > 0 && obj[0]?.metadata) {
              try {
                obj[0].metadata.attachments = JSON.parse(
                  obj[0].metadata.attachments
                );
              } catch {
                obj[0].metadata.attachments = [];
              }
            }
            if (obj.length > 0) m.metadata = obj[0].metadata;
          }
        });
        setMessages(messages);
        if (
          chat.messages != null &&
          chat.messages.length > 0 &&
          chat.messages.filter(
            (f) => f.isDraft !== undefined && f.isDraft === true
          ).length > 0
        ) {
          let obj = chat.messages.filter(
            (f) => f.isDraft !== undefined && f.isDraft === true
          )[0];
          setNewMessae(obj?.text);
        } else {
          setNewMessae('');
        }
      }
    }, [chat]);

    useEffect(() => {
      if (twilioChatId !== '') {
        console.log('twilioConversations', twilioConversations);
        const selectedConversation = twilioConversations.find(
          (it) => it.sid === twilioChatId
        );

        if (selectedConversation !== undefined) {
          setTwilioChatClient(selectedConversation);
          console.log(selectedConversation);
          // console.log(selectedConversation._events.messageAdded);
          // console.log(selectedConversation._events.messageAdded.length);
          if (selectedConversation._events.messageAdded.length > 0) {
            selectedConversation._events.messageAdded.splice(
              -selectedConversation._events.messageAdded.length
            );
          }
          if (selectedConversation._events.typingStarted.length > 0) {
            selectedConversation._events.typingStarted.splice(
              -selectedConversation._events.typingStarted.length
            );
          }
          if (selectedConversation._events.typingEnded.length > 0) {
            selectedConversation._events.typingEnded.splice(
              -selectedConversation._events.typingEnded.length
            );
          }
          selectedConversation.on('messageAdded', (m) => messageAdd(m));
          selectedConversation.on('typingStarted', (m) => startTyping(m));
          selectedConversation.on('typingEnded', (m) => endTyping(m));
        } else {
          AxiosPublicAPI({
            method: 'get',
            url: `${TWILIO_CHECKCHAT_URL}/${twilioChatId}`,
          }).then((t) => {
            if (t.data.status !== 'active') {
              setBlankTwilioId();
            }
          });

          setTwilioChatClient(null);
        }
      } else {
        setTwilioChatClient(null);
      }
    }, [twilioChatId, forceRefresh]);
    useEffect(() => {
      if (
        chatReplyTemplates !== undefined &&
        chatReplyTemplates !== null &&
        chatReplyTemplates.length > 0
      ) {
        setQuickReplies(chatReplyTemplates);
      }
    }, [chatReplyTemplates]);

    const onSearchKey = (e) => {
      if (e.target.value.length > 3) {
        var serachtext = e.target.value.toLowerCase();
        var resdata = chatReplyTemplates.filter((a) =>
          a.name.toLowerCase().includes(serachtext)
        );
        if (resdata.length > 0) {
          setQuickReplies(resdata);
        }
      } else {
        setQuickReplies(chatReplyTemplates);
      }
    };
    const messageAdd = (message) => {
      console.log('message added', message);
      console.log('message added', stateRef.current);
      const newMsgTitle = intl.formatMessage({
        id: 'dashboard.new_chat_message',
      });
      const dismissText = intl.formatMessage({ id: 'content.dismiss' });
      const openText = intl.formatMessage({ id: 'content.open' });
      console.log('message addeds', newMsgTitle, dismissText, openText);
      if (message?.conversation.sid === stateRef.current) {
        if (message.state.body.startsWith('imageUrl:')) {
          var m = {
            sender: message.state.author === getUserID() ? false : true,
            source: message.state.author === getUserID() ? 'Bot' : 'Visitor',
            text: JSON.stringify([
              {
                caption: '',
                url: [message.state.body.replace('imageUrl:', '')],
              },
            ]),
            time: moment(message.state.timestamp),
            type: 'ImageCarousel',
          };

          setMessages((messages) => [...messages, m]);
        } else if (message.state.body.startsWith('videoUrl:')) {
          var m = {
            sender: message.state.author === getUserID() ? false : true,
            source: message.state.author === getUserID() ? 'Bot' : 'Visitor',
            text: JSON.stringify([
              {
                caption: '',
                url: [message.state.body.replace('videoUrl:', '')],
              },
            ]),
            time: moment(message.state.timestamp),
            type: 'VideoCarousel',
          };

          setMessages((messages) => [...messages, m]);
        } else if (message.state.body.startsWith('audioUrl:')) {
          var m = {
            sender: message.state.author === getUserID() ? false : true,
            source: message.state.author === getUserID() ? 'Bot' : 'Visitor',
            text: JSON.stringify([
              {
                caption: '',
                url: [message.state.body.replace('audioUrl:', '')],
              },
            ]),
            time: moment(message.state.timestamp),
            type: 'AudioCarousel',
          };

          setMessages((messages) => [...messages, m]);
        } else {
          var m = {
            sender: message.state.author === getUserID() ? false : true,
            source: message.state.author === getUserID() ? 'Bot' : 'Visitor',
            text: message.state.body,
            time: moment(message.state.timestamp),
            type: 'messages',
          };
          setMessages((messages) => [...messages, m]);
        }

        if (messagesEndRef !== undefined && messagesEndRef.current !== null) {
          messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
        if (message.state.body === 'The user has left the conversation.') {
          setTwilioChatClient(null);
          closeTwilioConversation(
            stateRef.current,
            chat.conversationId,
            chat?.channel
          );
        }
      }
      console.log('author', message.state.author);
      if (message.state.author !== getUserID()) {
        if (!message.state.body.includes('left the conversation')) {
          console.log('message not for this conversation');
          try {
            // determine accent color from CSS var or stored theme (fallback)

            // show styled chat popup (uses project accent)
            if (!document.getElementById('myma-chat-popup-styles')) {
              const style = document.createElement('style');
              style.id = 'myma-chat-popup-styles';
              style.innerHTML = `                      
                              @keyframes myma-popup-in { from { transform: translateY(12px) scale(.98); opacity: 0 } to { transform: translateY(0) scale(1); opacity: 1 } }
                              .myma-chat-popup-container { position: fixed; right: 20px; bottom: 20px; z-index: 2147483647; display:flex; flex-direction: column; gap: 12px; align-items: flex-end; pointer-events: none; }
                              .myma-chat-popup { pointer-events: auto; width: 340px; background: linear-gradient(180deg,#fff,#fbfdff); border-radius: 10px; border: 1px solid rgba(15,23,36,0.08); box-shadow: 0 10px 30px rgba(18,36,63,0.12); overflow: hidden; font-family: Inter, Roboto, "Helvetica Neue", Arial, sans-serif; color:#1f2937; animation: myma-popup-in .18s ease both; }
                              .myma-chat-popup .header { display:flex; align-items:center; gap:10px; padding:12px 12px 6px 12px; }
                              .myma-chat-popup .avatar { width:40px; height:40px; border-radius:8px; object-fit:cover; display:flex; align-items:center; justify-content:center; overflow:hidden; }
                              .myma-chat-popup .avatar img { width:100%; height:100%; object-fit:cover; display:block; }
                              .myma-chat-popup .title { font-weight:600; font-size:14px; line-height:1; color:#0f1724; }
                              .myma-chat-popup .meta { font-size:12px; color:#64748b; margin-top:4px; }
                              .myma-chat-popup .body { padding:6px 12px 12px 12px; font-size:13px; color:#0f1724; max-height:110px; overflow:auto; line-height:1.35; }
                              .myma-chat-popup .actions { display:flex; justify-content:flex-end; gap:8px; padding:8px 12px 12px 12px; }                      
                              .myma-chat-popup .close-x { position:absolute; right:8px; top:6px; background:transparent; border:0; font-size:16px; color:#94a3b8; cursor:pointer; }
                              @media (max-width:420px){ .myma-chat-popup{ width:calc(100% - 40px); right:10px; left:10px; } .myma-chat-popup-container{ right:10px; left:10px; align-items:center; } }
                            `;
              document.head.appendChild(style);
            }

            // ensure container exists (stacks popups)
            let container = document.getElementById(
              'myma_chat_popup_container'
            );
            if (!container) {
              container = document.createElement('div');
              container.id = 'myma_chat_popup_container';
              container.className = 'myma-chat-popup-container';
              document.body.appendChild(container);
            }

            // derive message text safely
            let contentMsg = message.state.body;

            const botMsg =
              contentMsg &&
                !contentMsg.startsWith('imageUrl:') &&
                !contentMsg.startsWith('videoUrl:') &&
                !contentMsg.startsWith('audioUrl:')
                ? String(contentMsg)
                : 'New media message received';

            const popupId = `myma_chat_popup_${message.conversation.sid || Date.now()
              }`;

            // remove existing same-conversation popup
            const existing = document.getElementById(popupId);
            if (existing) existing.remove();

            // prefer visitor/conversation avatar -> message avatar -> login profile -> fallback bot-off
            let avatarSrc =
              'https://bmbuiassetsprod.blob.core.windows.net/images/profile_pic.png';

            const popup = document.createElement('div');
            popup.id = popupId;
            popup.className = 'myma-chat-popup';
            popup.setAttribute('role', 'dialog');
            popup.setAttribute('aria-live', 'polite');
            popup.innerHTML = `
                            <div class="header">
                              <div class="avatar">
                                <img src="${avatarSrc}" alt="user" />
                              </div>
                              <div style="flex:1;position:relative">
                                <div class="title">${newMsgTitle}</div>                        
                              </div>
                              <button class="close-x" aria-label="Dismiss">&times;</button>
                            </div>
                            <div class="body">${(function () {
                const esc = (s) =>
                  String(s)
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;');
                return esc(botMsg);
              })()}</div>
                            <div class="actions">
                              <button class="btn-dismiss add-button btn btn-secondary btn-xs">${dismissText}</button>
                              <button class="btn-open add-button btn btn btn-primary btn-xs">${openText}</button>
                            </div>
                          `;

            // close/dismiss handlers
            popup.querySelector('.close-x').addEventListener('click', (e) => {
              e.stopPropagation();
              popup.remove();
            });
            popup
              .querySelector('.btn-dismiss')
              .addEventListener('click', (e) => {
                e.stopPropagation();
                popup.remove();
              });

            // open handler - navigate to agent-assist with incomingchatId
            popup.querySelector('.btn-open').addEventListener('click', (e) => {
              e.stopPropagation();
              try {
                window.dispatchEvent(
                  new CustomEvent('myma_set_active_chat', {
                    detail: { twilioId: message.conversation.sid },
                  })
                );
              } catch (err) {
                window.location.href = '/app/pages/agent-assist';
              }
              popup.remove();
            });

            // clicking the body also opens conversation
            popup.addEventListener('click', (e) => {
              if (
                e.target.closest('button') ||
                e.target.classList.contains('close-x')
              )
                return;
              try {
                window.dispatchEvent(
                  new CustomEvent('myma_set_active_chat', {
                    detail: { twilioId: message.conversation.sid },
                  })
                );
              } catch (err) {
                window.location.href = '/app/pages/agent-assist';
              }
              popup.remove();
            });

            const createPopup = () => {
              // remove existing same-conversation popup
              const existingImmediate = document.getElementById(popupId);
              if (existingImmediate) existingImmediate.remove();
              container.appendChild(popup);
              // auto-remove after 10 seconds (adjust as wanted)
              // const autoRemoveMs = 3600000;
              // setTimeout(() => {
              //   const el = document.getElementById(popupId);
              //   if (el) el.remove();
              // }, autoRemoveMs);
            };

            // helper to clear any existing pending timer for a conversation
            const clearPopupTimer = (sid) => {
              try {
                if (
                  sid &&
                  popupTimersRef.current &&
                  popupTimersRef.current[sid]
                ) {
                  clearTimeout(popupTimersRef.current[sid]);
                  delete popupTimersRef.current[sid];
                }
              } catch (err) {
                console.error('Error clearing popup timer:', err);
              }
            };

            // If this message belongs to the currently-open conversation, delay showing
            // the popup by 30 seconds (and store the timer so it can be cancelled if
            // the agent starts typing). Otherwise show immediately.
            if (
              message.conversation &&
              message.conversation.sid === stateRef.current
            ) {
              // clear any previous pending timer for this conversation
              clearPopupTimer(message.conversation.sid);
              const timerId = setTimeout(() => {
                try {
                  createPopup();
                } catch (err) {
                  console.error('Error showing delayed chat popup:', err);
                } finally {
                  try {
                    if (
                      popupTimersRef.current &&
                      popupTimersRef.current[message.conversation.sid]
                    ) {
                      delete popupTimersRef.current[message.conversation.sid];
                    }
                  } catch (ignore) { }
                }
              }, 120000);
              popupTimersRef.current[message.conversation.sid] = timerId;
            } else {
              createPopup();
            }
          } catch (err) {
            console.error('Error showing styled chat popup:', err);
          }
        }
      }
    };

    const startTyping = (message) => {
      if (message.conversation.sid === stateRef.current) {
        setTyping(true);
      }
    };

    const endTyping = (message) => {
      if (message.conversation.sid === stateRef.current) {
        setTyping(false);
      }
    };

    // cleanup any pending popup timers on unmount
    useEffect(() => {
      return () => {
        try {
          Object.values(popupTimersRef.current || {}).forEach((t) =>
            clearTimeout(t)
          );
          popupTimersRef.current = {};
        } catch (err) {
          // ignore
        }
      };
    }, []);

    const handleKeyPress = (target) => {
      if (target.charCode == 13) {
        sendMessage();
      }
    };

    const handleChangeTemplate = (id) => {
      const reply = quickReplies.filter((m) => m.id === id);
      if (reply.length > 0) {
        setNewMessae(reply[0].message);
      }
      setIsQuick(false);
    };

    useEffect(() => {
      if (accessToken !== '') {
      }
    }, [accessToken]);

    const handleMessage = (source, e) => {
      if (source === 'user') setNewMessae(e);
    };
    const clickquickreply = () => {
      setIsQuick(!isQuick);
    };
    return (
      <Fragment>
        {chat?.channel !== 'EmailDirectLine' ? (
          <Card
            className="cardHeight mb-2"
            style={{
              //overflow: 'scroll',
              backgroundColor: chat ? 'rgb(233, 238, 244)' : '#fff',
            }}
          >
            <div style={{ height: '100%' }} className="ml-2 mt-2">
              <div
                onClick={() => setIsQuick(false)}
                className={`scroll ${twilioChatClient !== null && twilioChatClient !== undefined ? 'divHeightActive' : 'divHeight'}`}
              >
                {chat && (
                  <div>
                    {messages != null &&
                      messages.length > 0 &&
                      messages.map((item, index) => {
                        return (
                          <ChatMessage
                            key={index}
                            sender={item.sender}
                            item={item}
                            avatar={
                              chat.channel === 'PhoneSuite'
                                ? bot_icon
                                : chat.avatar
                            }
                            colors={chat.colours}
                            translateLang={translateLang}
                            isTranslate={isTranslate}
                          />
                        );
                      })}
                  </div>
                )}
                <div ref={messagesEndRef} />
              </div>
              {console.log('twilioChatClient', twilioChatClient)}
              {twilioChatClient !== null && twilioChatClient !== undefined && (
                <Fragment>
                  <InputGroup
                    className="mt-3"
                    style={{ position: 'absolute', left: 0, bottom: 0 }}
                  >
                    {chat?.channel === 'WhatsApp' && (
                      <Fragment>
                        {!isLatestConversation &&
                          chat?.channel === 'WhatsApp' ? (
                          <InputGroupAddon addonType="append">
                            <Button
                              color="secondary"
                              onClick={() =>
                                openWhatsAppTab(
                                  chat?.visitor?.whatsAppSenderPhoneNumber || ''
                                )
                              }
                              title="Attach File"
                            >
                              <i className="simple-icon-paper-clip"></i>
                            </Button>
                          </InputGroupAddon>
                        ) : (
                          <InputGroupAddon addonType="append">
                            <Button
                              color="secondary"
                              onClick={handleUploadLiveChatAttachment}
                              title="Attach File"
                            >
                              <i className="simple-icon-paper-clip"></i>
                            </Button>
                          </InputGroupAddon>
                        )}
                      </Fragment>
                    )}
                    <IntlProvider
                      locale={currentLang}
                      messages={messagesForLocale}
                    >
                      <ChatInput
                        value={newmessage}
                        onChange={handleChange}
                        onKeyPress={handleKeyPress}
                        disabled={true}
                        isLatestConversation={isLatestConversation}
                        chat={chat}
                      />
                    </IntlProvider>
                    {quickReplies && quickReplies.length > 0 && (
                      <div className="quicktemp-div">
                        <button
                          type="button"
                          aria-haspopup="true"
                          aria-expanded="true"
                          class="quick btn btn-light"
                          style={{ backgroundColor: ' rgb(255, 255, 255);' }}
                          onClick={() => clickquickreply()}
                        >
                          <i class="simple-icon-arrow-up-circle"></i>
                        </button>
                        {isQuick && (
                          <Card
                            style={{
                              position: 'absolute',
                              zIndex: '1',
                              bottom: '2.8rem',
                              boxShadow:
                                '0 1px 20px 20px rgb(0 0 0 / 4%), 0 1px 6px rgb(0 0 0 / 4%)',
                            }}
                          >
                            <CardBody className="quick">
                              {quickReplies.map((element, index) => {
                                return (
                                  <span
                                    className="dropdown-item"
                                    onClick={() =>
                                      handleChangeTemplate(element.id)
                                    }
                                  >
                                    {' '}
                                    {element.name}
                                  </span>
                                );
                              })}
                            </CardBody>
                            <div className="search-quicktemp">
                              <input
                                type="text"
                                placeholder="Search"
                                onKeyUp={(e) => onSearchKey(e)}
                              ></input>
                            </div>
                          </Card>
                        )}
                      </div>
                      // <UncontrolledDropdown addonType="prepend">
                      //   <DropdownToggle
                      //     caret
                      //     color="light"
                      //     size="m"
                      //     style={{ backgroundColor: '#fff' }}
                      //     className="quick"
                      //   ></DropdownToggle>
                      //   <DropdownMenu className="quick">
                      //     <div className="search-quicktemp">
                      //       <input
                      //         type="text"
                      //         placeholder="Search"
                      //         onKeyUp={(e) => onSearchKey(e)}
                      //       ></input>
                      //     </div>
                      //     {quickReplies.map((element, index) => {
                      //       return (
                      //         <DropdownItem
                      //           onClick={() => handleChangeTemplate(element.id)}
                      //           key={index}
                      //         >
                      //           {element.name}
                      //         </DropdownItem>
                      //       );
                      //     })}
                      //   </DropdownMenu>
                      // </UncontrolledDropdown>
                    )}
                    {!isLatestConversation && chat?.channel === 'WhatsApp' ? (
                      <InputGroupAddon addonType="prepend">
                        <Button
                          onClick={() =>
                            openWhatsAppTab(
                              chat?.visitor?.whatsAppSenderPhoneNumber || ''
                            )
                          }
                        >
                          <i className="simple-icon-paper-plane"></i>
                        </Button>
                        <Button
                          style={{ marginLeft: '1px' }}
                          color="danger"
                          onClick={closeChat}
                        >
                          <i className="iconsminds-power-2"></i>
                        </Button>
                      </InputGroupAddon>
                    ) : (
                      <InputGroupAddon addonType="prepend">
                        <Button onClick={() => sendMessage()}>
                          <i className="simple-icon-paper-plane"></i>
                        </Button>
                        <Button
                          style={{ marginLeft: '1px' }}
                          color="danger"
                          onClick={closeChat}
                        >
                          <i className="iconsminds-power-2"></i>
                        </Button>
                      </InputGroupAddon>
                    )}
                    {isTyping && (
                      <div class="typing-indicator-inline">
                        <div class="typing-indicator-disp">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                    )}
                  </InputGroup>

                  {/* <p className="user-typing">{isTyping && 'User is typing...'}</p> */}
                </Fragment>
              )}
            </div>
          </Card>
        ) : (
          <Card
            className="cardHeight"
            style={{
              //overflow: 'scroll',
              backgroundColor: chat ? `${chat.colours.botBackground}` : '#fff',
            }}
          >
            <style>{styles}</style>
            <CardBody style={{ height: `100%` }}>
              <div
                className={`scroll mail-div ${twilioChatClient !== null && twilioChatClient !== undefined
                    ? 'divHeightActive'
                    : 'divHeight'
                  }`}
                style={{
                  height: `${chat?.status === 'Opened' ? '75%' : '100%'}`,
                  overflowX: 'hidden',
                  paddingBottom: '0.5rem',
                }}
              >
                {chat && (
                  <Fragment>
                    {messages != null &&
                      messages.length > 0 &&
                      messages
                        .filter(
                          (f) => f.isDraft === undefined || f?.isDraft === false
                        )
                        .map((item, index) => {
                          return (
                            <ChatMessage
                              key={index}
                              sender={item.sender}
                              item={item}
                              visitor={chat?.visitor}
                              channel={chat?.channel}
                              metadata={item?.metadata}
                              avatar={
                                chat.channel === 'PhoneSuite'
                                  ? bot_icon
                                  : chat.avatar
                              }
                              colors={chat.colours}
                              translateLang={translateLang}
                              isTranslate={isTranslate}
                            />
                          );
                        })}
                  </Fragment>
                )}
                <div ref={messagesEndRef} />
              </div>

              {chat?.status === 'Opened' && (
                <div style={{ height: `${replayDivHeight}%` }}>
                  {' '}
                  <Row
                    style={{
                      border: '1px solid black',
                      borderRadius: '20px',
                      margin: '0px 0px 10px 0px',
                      position: 'absolute',
                      bottom: '0px',
                      width: '93%',
                    }}
                  >
                    {' '}
                    <ReactQuill
                      theme="snow"
                      style={{
                        width: '100%',
                        height: '100%',
                      }}
                      value={newmessage}
                      onChange={(content, delta, source) =>
                        handleMessage(source, content)
                      }
                      modules={quillModules}
                      formats={quillFormats}
                      placeholder="Reply"
                      name="message"
                    />
                    <Colxx md="8" className="my-2 text-right">
                      {/* {quickReplies && quickReplies.length > 0 && (
                        <UncontrolledDropdown addonType="append">
                          <DropdownToggle
                            caret
                            color="light"
                            size="m"
                            style={{ backgroundColor: '#fff' }}
                            className="quick"
                          ></DropdownToggle>
                          <DropdownMenu className="quick">
                            {quickReplies.map((element, index) => {
                              return (
                                <DropdownItem
                                  onClick={() =>
                                    handleChangeTemplate(element.id)
                                  }
                                  key={index}
                                >
                                  {element.name}
                                </DropdownItem>
                              );
                            })}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      )} */}
                      {emailIntegration &&
                        emailIntegration?.channelDetails?.autonomousReplies &&
                        emailIntegration?.channelDetails.autonomousReplies
                          ?.enabled && (
                          <AutonomousReplies
                            propertyId={chat?.propertyId}
                            messages={chat?.messages}
                            sessionId={chat?.sessionId}
                            conversationId={chat?.conversationId}
                            locale={locale}
                            handleMessage={(source, content) =>
                              handleMessage(source, content)
                            }
                            channelDetails={emailIntegration?.channelDetails}
                          ></AutonomousReplies>
                        )}
                      <div
                        onClick={handleUploadAttachment}
                        className="quill-footer-button"
                        title="Attach File"
                      >
                        <i className="simple-icon-paper-clip"></i>
                        {files !== undefined && files.length > 0 ? (
                          <span className="ml-1">{files.length}</span>
                        ) : null}
                      </div>
                    </Colxx>
                    <Colxx md="4" className="my-2 text-right">
                      <div className="send-div">
                        <Button
                          onClick={() => sendMessage()}
                          disabled={
                            newmessage !== '' && newmessage !== '<p><br/></p>'
                              ? false
                              : true
                          }
                          color="primary"
                          style={{
                            borderRadius: '5px',
                          }}
                          size="xs"
                          outline
                        >
                          Send
                        </Button>
                        <div className="position-relative d-none d-sm-inline-block">
                          <UncontrolledDropdown
                            className="dropdown-menu-right"
                            style={{ borderRadius: '5px' }}
                          >
                            <DropdownToggle
                              style={{
                                borderRadius: '5px',
                                padding: '4px',
                              }}
                              caret={'up'}
                              color="primary"
                              className="btn-xs"
                              outline
                            ></DropdownToggle>
                            <DropdownMenu up>
                              <DropdownItem onClick={saveAsDraft}>
                                Save as draft
                              </DropdownItem>
                              {chatReplyTemplates &&
                                chatReplyTemplates.length > 0 &&
                                chatReplyTemplates.filter(
                                  (f) => f.templateChannel === 'Email'
                                ).length > 0 && (
                                  <DropdownItem onClick={handleTemplate}>
                                    {' '}
                                    Templates{' '}
                                  </DropdownItem>
                                )}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </div>
                      </div>

                      {chat?.channel !== 'EmailDirectLine' && (
                        <Button
                          style={{ marginLeft: '5px' }}
                          color="danger"
                          size="xs"
                          outline
                          onClick={closeChat}
                        >
                          End
                        </Button>
                      )}
                    </Colxx>
                    {isTyping && (
                      <div class="typing-indicator-inline">
                        <div class="typing-indicator-disp">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                    )}
                  </Row>
                </div>
              )}
            </CardBody>
          </Card>
        )}
        {uploadAttachment && (
          <UploadAttachments
            visible={uploadAttachment}
            files={files}
            toggleModal={handleUploadAttachment}
            handleFiles={(e) => handleFiles(e)}
          ></UploadAttachments>
        )}

        {uploadLiveChatAttachment && (
          <UploadLiveChatAttachments
            visible={uploadLiveChatAttachment}
            files={files}
            image={image}
            toggleModal={handleUploadLiveChatAttachment}
            handleFiles={(e, image) => handleLiveChatFiles(e, image)}
          ></UploadLiveChatAttachments>
        )}

        {showTemplate && (
          <Templates
            visible={showTemplate}
            quickReplies={chatReplyTemplates}
            toggleModal={handleTemplate}
            availabilityIntegration={availabilityIntegration}
            messages={chat?.messages}
            propertyId={propertyId}
            saveAsDraft={saveAsDraft}
            handleMessage={handleMessage}
            conversationId={chat?.conversationId}
            locale={locale}
            channelDetails={emailIntegration?.channelDetails}
            sendMessage={sendMessage}
          ></Templates>
        )}
      </Fragment>
    );
  }
);

export default Chat;
